import type { TranslationCatalog } from "../TranslationManager";

export const he: TranslationCatalog = {
  "labels.cardNumber": "מספר כרטיס",
  "labels.expirationDate": "תאריך תפוגה",
  "labels.cvc": "קוד אבטחה",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "MM / YY",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "מספר הכרטיס שלך אינו תקין.",
  "errors.invalidExpiryDate": "תאריך התפוגה של הכרטיס שלך אינו תקין.",
  "errors.invalidCvc": "קוד האבטחה של הכרטיס שלך אינו תקין.",
  "errors.incompleteCardNumber": "מספר הכרטיס שלך אינו שלם.",
  "errors.incompleteExpiryDate": "תאריך התפוגה של הכרטיס שלך אינו שלם.",
  "errors.incompleteCvc": "קוד האבטחה של הכרטיס שלך אינו שלם.",
  "errors.expiredCard": "פג תוקף הכרטיס שלך.",
  "aria.cardNumber": "מספר כרטיס",
  "aria.expirationDate": "תאריך תפוגה",
  "aria.cvc": "קוד אבטחה",
  "aria.cardInput": "פרטי כרטיס",
};
